import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HelperService } from '../../../core/services/helper.service';
import { PopupAndNotifService } from '../../../core/services/popup-and-notif.service';
import { combineLatest, map } from 'rxjs';

/**
 * @title Progress Spinner Component
 * Composant spinner réutilisable contrôlé par HelperService OU PopupAndNotifService
 */
@Component({
  selector: 'app-progress-spinner',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  template: `
    <div class="spinner-overlay" *ngIf="isLoading$ | async">
      <div class="spinner-container">
        <mat-spinner diameter="50" strokeWidth="5"></mat-spinner>
        <p class="spinner-text" *ngIf="message$ | async as message">
          {{ message }}
        </p>
      </div>
    </div>
  `,
  styles: [`
    .spinner-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      backdrop-filter: blur(3px);
    }

    .spinner-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      background: var(--spinner-bg, #ffffff);
      padding: 40px;
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    }

    .spinner-text {
      color: var(--spinner-text, #333333);
      font-size: 16px;
      font-weight: 500;
      margin: 0;
      text-align: center;
    }

    /* Mode nuit */
    :host-context(.dark-theme) .spinner-container {
      --spinner-bg: #1a2537;
      --spinner-text: #ffffff;
    }

    /* Couleur du spinner selon le thème */
    ::ng-deep .mat-mdc-progress-spinner circle {
      stroke: #5D87FF;
    }

    :host-context(.dark-theme) ::ng-deep .mat-mdc-progress-spinner circle {
      stroke: #5D87FF;
    }
  `]
})
export class ProgressSpinnerComponent {
  // Combiner les deux sources de spinner (HelperService ET PopupAndNotifService)
  isLoading$ = combineLatest([
    this.helperService.spinnerLoading$,
    this.popupAndNotifService.spinnerLoading$
  ]).pipe(
    map(([helperLoading, popupLoading]) => helperLoading || popupLoading)
  );

  // Combiner les messages des deux sources (prioriser le message non-vide)
  message$ = combineLatest([
    this.helperService.spinnerMessage$,
    this.popupAndNotifService.spinnerMessage$
  ]).pipe(
    map(([helperMsg, popupMsg]) => popupMsg || helperMsg)
  );

  constructor(
    public helperService: HelperService,
    public popupAndNotifService: PopupAndNotifService
  ) {}
}

